import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { sdkTypes } from '@vansite/ts-sharetribe-flex-sdk';
import React from 'react';
import { useIntl } from 'react-intl';

import { formatMoney } from '../../../util/currency';
import { FormattedMessage } from '../../../util/reactIntl';
import { LINE_ITEM_PROVIDER_COMMISSION, LINE_ITEM_PROVIDER_NIGHTLY_COMMISSION } from '../../../util/types';
import { itemValueStyles, lineItemStyles } from './BookingBreakdown.styles';

const { Money } = sdkTypes;

const LineItemProviderCommissionRefundMaybe = ({ transaction, isProvider }) => {
  const intl = useIntl();

  if (!isProvider) return null;

  const refund = transaction.attributes.lineItems.reduce(
    (acc, item) => {
      const isCommission =
        item.code === LINE_ITEM_PROVIDER_COMMISSION ||
        item.code === LINE_ITEM_PROVIDER_NIGHTLY_COMMISSION;
      const isReversal = item.reversal || item.lineTotal.amount > 0;
      if (isCommission && isReversal) {
        acc.amount = acc.amount + item.lineTotal.amount;
      }
      return acc;
    },
    new Money(0, transaction.attributes.payinTotal.currency)
  );

  return isProvider && refund.amount > 0 ? (
    <Box sx={lineItemStyles}>
      <Typography sx={{ flex: 1 }} variant="lineItemLabel">
        <FormattedMessage id="BookingBreakdown.refundProviderFee" />
      </Typography>
      <Typography sx={itemValueStyles} variant="lineItemLabel">{formatMoney(intl, refund)}</Typography>
    </Box>
  ) : null;
};

export default LineItemProviderCommissionRefundMaybe;
